/* tslint:disable:max-line-length */
import { DefaultMessages, SegmentSpecificMessages } from '@sheerid/jslib';

type ExtendedMessages = {
    errorFraud: string,
    errorId: {
        noRemainingRewardCodes: string,
    },
    step: {
        personalInfo: {
            title: string,
        },
        success: {
            title: string,
            subtitle: string,
            codeText: string,
            thanks: string,
        },
        docUpload: {
            title: string,
            subtitle: string,
        },
        pending: {
            title: string,
        },
    },
};

export const medicalMessagesEN: DefaultMessages & SegmentSpecificMessages & ExtendedMessages = {
    birthDate: 'Date of birth',
    branchOfService: 'Branch of service',
    changeLanguage: 'Change language',
    country: 'Country',
    countries: {
        AD: 'Andorra',
        AE: 'United Arab Emirates',
        AF: 'Afghanistan',
        AG: 'Antigua and Barbuda',
        AI: 'Anguilla',
        AL: 'Albania',
        AM: 'Armenia',
        AN: 'Netherlands Antilles',
        AO: 'Angola',
        AR: 'Argentina',
        AS: 'American Samoa',
        AT: 'Austria',
        AU: 'Australia',
        AW: 'Aruba',
        AZ: 'Azerbaijan',
        BA: 'Bosnia-Herzegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'Belgium',
        BF: 'Burkina Faso',
        BG: 'Bulgaria',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BM: 'Bermuda',
        BN: 'Brunei Darussalam',
        BO: 'Bolivia',
        BR: 'Brazil',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Bouvet Island',
        BW: 'Botswana',
        BY: 'Belarus',
        BZ: 'Belize',
        CA: 'Canada (exclues Québec)',
        CF: 'Central African Republic',
        CG: 'Congo',
        CH: 'Switzerland',
        CI: 'Ivory Coast (Cote D\'Ivoire)',
        CK: 'Cook Islands',
        CL: 'Chile',
        CM: 'Cameroon',
        CN: 'China',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Cape Verde',
        CY: 'Cyprus',
        CZ: 'Czech Republic',
        DE: 'Germany',
        DJ: 'Djibouti',
        DK: 'Denmark',
        DM: 'Dominica',
        DO: 'Dominican Republic',
        DZ: 'Algeria',
        EC: 'Ecuador',
        EE: 'Estonia',
        EG: 'Egypt',
        EH: 'Western Sahara',
        ER: 'Eritrea',
        ES: 'Spain',
        ET: 'Ethiopia',
        FI: 'Finland',
        FJ: 'Fiji',
        FK: 'Falkland Islands',
        FM: 'Micronesia',
        FO: 'Faroe Islands',
        FR: 'France',
        GA: 'Gabon',
        GB: 'United Kingdom',
        GD: 'Grenada',
        GE: 'Georgia',
        GF: 'French Guyana',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Greenland',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe (French)',
        GQ: 'Equatorial Guinea',
        GR: 'Greece',
        GS: 'South Georgia & South Sandwich Islands',
        GT: 'Guatemala',
        GU: 'Guam (USA)',
        GW: 'Guinea Bissau',
        GY: 'Guyana',
        HK: 'Hong Kong',
        HM: 'Heard and McDonald Islands',
        HN: 'Honduras',
        HR: 'Croatia',
        HT: 'Haiti',
        HU: 'Hungary',
        ID: 'Indonesia',
        IE: 'Ireland',
        IL: 'Israel',
        IN: 'India',
        IO: 'British Indian Ocean Territory',
        IQ: 'Iraq',
        IR: 'Iran',
        IS: 'Iceland',
        IT: 'Italy',
        JM: 'Jamaica',
        JO: 'Jordan',
        JP: 'Japan',
        KE: 'Kenya',
        KG: 'Kyrgyzstan',
        KH: 'Cambodia',
        KI: 'Kiribati',
        KM: 'Comoros',
        KN: 'Saint Kitts & Nevis Anguilla',
        KP: 'North Korea',
        KR: 'South Korea',
        KW: 'Kuwait',
        KY: 'Cayman Islands',
        KZ: 'Kazakhstan',
        LA: 'Laos',
        LB: 'Lebanon',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Lithuania',
        LU: 'Luxembourg',
        LV: 'Latvia',
        LY: 'Libya',
        MA: 'Morocco',
        MC: 'Monaco',
        MD: 'Moldavia',
        ME: 'Montenegro',
        MG: 'Madagascar',
        MH: 'Marshall Islands',
        MK: 'Macedonia',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolia',
        MO: 'Macau',
        MP: 'Northern Mariana Islands',
        MQ: 'Martinique (French)',
        MR: 'Mauritania',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Maldives',
        MW: 'Malawi',
        MX: 'Mexico',
        MY: 'Malaysia',
        MZ: 'Mozambique',
        NA: 'Namibia',
        NC: 'New Caledonia (French)',
        NE: 'Niger',
        NF: 'Norfolk Island',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Netherlands',
        NO: 'Norway',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'New Zealand',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polynesia (French)',
        PG: 'Papua New Guinea',
        PH: 'Philippines',
        PK: 'Pakistan',
        PL: 'Poland',
        PM: 'Saint Pierre and Miquelon',
        PN: 'Pitcairn Island',
        PR: 'Puerto Rico',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Qatar',
        RE: 'Reunion (French)',
        RO: 'Romania',
        RS: 'Serbia',
        RU: 'Russian Federation',
        RW: 'Rwanda',
        SA: 'Saudi Arabia',
        SB: 'Solomon Islands',
        SC: 'Seychelles',
        SD: 'Sudan',
        SE: 'Sweden',
        SG: 'Singapore',
        SH: 'Saint Helena',
        SI: 'Slovenia',
        SK: 'Slovak Republic',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Suriname',
        ST: 'Saint Tome (Sao Tome) and Principe',
        SV: 'El Salvador',
        SY: 'Syria',
        SZ: 'Swaziland',
        TC: 'Turks and Caicos Islands',
        TD: 'Chad',
        TF: 'French Southern Territories',
        TG: 'Togo',
        TH: 'Thailand',
        TJ: 'Tajikistan',
        TK: 'Tokelau',
        TM: 'Turkmenistan',
        TN: 'Tunisia',
        TO: 'Tonga',
        TR: 'Turkey',
        TT: 'Trinidad and Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        UA: 'Ukraine',
        UG: 'Uganda',
        UM: 'USA Minor Outlying Islands',
        US: 'United States',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VA: 'Vatican City State',
        VC: 'Saint Vincent & Grenadines',
        VE: 'Venezuela',
        VG: 'Virgin Islands (British)',
        VI: 'Virgin Islands (USA)',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis and Futuna Islands',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Yemen',
        YT: 'Mayotte',
        ZA: 'South Africa',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
    },
    dateTime: {
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December',
        month: 'Month',
        day: 'Day',
        year: 'Year',
        '20_MIN': '20 minutes',
        '2_HOURS': '2 hours',
        '24_HOURS': '24 hours',
        '3_DAY': '3 days',
        A_FEW_MINUTES: 'a few minutes',
        A_FEW_HOURS: 'a few hours',
        A_FEW_DAYS: 'a few days',
    },
    dischargeDate: 'Discharge date',
    emailAddress: 'Email address',
    emailExplanation: 'Needed to send you your unique code',
    schoolName: '', // N/A
    phoneNumber: 'US Mobile Number*<span class="sid-field__label-explanation">Only US numbers are supported</span>',
    error: 'Error',
    limitExceededError: 'Verification Limit Exceeded',
    errorFraud: 'Something went wrong',
    firstName: 'First name',
    howDoesReviewWork: 'How does review work?',
    howDoesVerifyingWork: 'How does verifying work?',
    informationTransferredToUS: 'Your information will be transferred to the United States and will be treated according to SheerID’s privacy policy.',
    lastName: 'Last name',
    loading: 'Loading...',
    locales: {
        ar: 'Arabic',
        bg: 'Bulgarian',
        cz: 'Czech',
        da: 'Danish',
        de: 'German',
        el: 'Greek',
        'en-GB': 'English (UK)',
        'en-US': 'English',
        'es-ES': 'Spanish (Spain)',
        es: 'Spanish',
        fi: 'Finnish',
        'fr-CA': 'French (Canadian)',
        fr: 'French',
        hr: 'Croatian',
        hu: 'Hungarian',
        id: 'Indonesian',
        is: 'Icelandic',
        it: 'Italian',
        iw: 'Hebrew',
        ja: 'Japanese',
        ko: 'Korean',
        lt: 'Lithuanian',
        ms: 'Malay',
        nl: 'Dutch',
        no: 'Norwegian',
        pl: 'Polish',
        'pt-BR': 'Portuguese (Brazil)',
        pt: 'Portuguese',
        ro: 'Romanian',
        ru: 'Russia',
        sk: 'Slovak',
        sl: 'Slovenian',
        sr: 'Serbian',
        sv: 'Swedish',
        tr: 'Turkish',
        'zh-HK': 'Chinese (Hong Kong)',
        zh: 'Chinese (Traditional)',
    },
    militaryStatus: 'Military status',
    noOptions: 'No options',
    personalInformation: 'Personal Information',
    personalOrSchoolIsFine: 'Personal or school email is fine',
    postalCode: 'Postal code',
    poweredBy: 'Verification services powered by SheerID',
    requiredFields: 'All fields are required',
    school: 'School',
    sheeridFaqs: 'Frequently asked questions',
    studentInfoShared: 'Information entered into this web form will be used for verification purposes. The information will be shared with {companyName}. ',
    universityName: 'University name',
    verifyAndContinue: 'Verify and continue',
    verificationPurposesOnly: 'Used for verification purposes only',
    verifyMyStudentStatus: 'Verify My Student Status',
    verifyMyTeacherStatus: 'Verify My Teacher Status',
    verifyMyMilitaryStatus: 'Verify My Military Status',
    verifyMyMedicalProfessionalStatus: 'VERIFY AND CONTINUE',
    verifyMyEmploymentStatus: 'Verify My Employee Status',
    status: 'Status',
    VETERAN: 'Veteran',
    MILITARY_RETIREE: 'Military Retiree',
    RESERVIST: 'Reservist',
    ACTIVE_DUTY: 'Active Duty',
    MILITARY_FAMILY: 'Registered Military Dependent',
    FIREFIGHTER: 'Firefighter',
    POLICE: 'Police',
    EMT: 'EMT',
    organization: 'Organization',
    firstResponderInfoShared: "Information entered into this web form will be used for verification purposes only.  This information is subject to Nike's <a class='sid-link' href='http://agreementservice.svs.nike.com/rest/agreement?agreementType=termsOfUse&uxId=com.nike.unite&country=US&language=en&requestType=redirect' target='_blank'>Terms of Use</a> and <a class='sid-link' href='http://agreementservice.svs.nike.com/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.commerce.nikedotcom.web&country=US&language=en&requestType=redirect' target='_blank'>Privacy Policy</a>.",
    verifyMyFirstResponderStatus: 'Verify My First Responder Status',
    MedicalProfessionalInfoShared: "Information entered into this web form will be used for verification and fraud mitigation purposes only. This information is subject to Nike's <a class='sid-link' href='http://agreementservice.svs.nike.com/rest/agreement?agreementType=termsOfUse&uxId=com.nike.unite&country=US&language=en&requestType=redirect' target='_blank'>Terms of Use</a> and <a class='sid-link' href='http://agreementservice.svs.nike.com/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.commerce.nikedotcom.web&country=US&language=en&requestType=redirect' target='_blank'>Privacy Policy</a>.",
    militaryInfoShared: 'Information entered here will be used for verification purposes.',
    tryAgain: 'Try again',
    errorId: {
        internalServerError: 'Internal server error',
        noRemainingRewardCodes: "Sorry, this offer is closed and we can't verify you at this time. Please try again later.",
        noProgram: 'No program found',
        fraudRulesReject: `<span class="sid-error-fraud">We're unable to verify your identity using the information you submitted. Please check the following and try again.<br>
        <ul class="sid-error-fraud__list">
            <li>Your email address can receive emails</li>
            <li>Your mobile phone number can receive SMS text messages</li>
            <li>You are using your own phone or computer and not a shared device</li>
        </ul><br></span>
        <span class="sid-error-fraud-footer">Still having trouble? <a href="https://verify.sheerid.com/verification-support/feedback.html?token=&locale=en_US&pid={programId}" class="sid-link">Contact SheerID's support team</a> to confirm your identity.</span>`,
        noVerification: 'No verification found',
        expiredProgram: 'This link is no longer active',
        invalidProgram: 'Invalid program',
        invalidStep: 'Invalid step',
        invalidMilitaryStatus: 'Invalid military status',
        invalidFirstResponderStatus: 'Invalid first responder status',
        invalidOrganization: 'You must select an organization from the list',
        invalidFirstName: 'Invalid first name',
        invalidLastName: 'Invalid last name',
        invalidMemberId: 'Invalid ID Number',
        invalidBirthDate: 'Invalid birth date',
        invalidEmail: 'Invalid email',
        invalidPhoneNumber: 'Invalid mobile number',
        invalidCountry: 'Invalid country',
        invalidPostalCode: 'Invalid postal code',
        invalidAddress: 'Invalid address',
        invalidCity: 'Invalid city',
        invalidState: 'Invalid state',
        underagePerson: 'Persons under age 16 are not eligible for this offer.',
        outsideAgePerson: 'Birthdate is not eligible for this offer.',
        futureBirthDate: 'Future birthdate',
        unsupportedDocMimeType: 'One or more files is an unsupported format',
        invalidFileSizeEmpty: 'One or more files is empty',
        invalidFileSizeMax: 'One or more files is too large (max: 10MB)',
        invalidNumberOfFiles: 'Maximum number of files exceeded (max: 5)',
        invalidDocUploadToken: 'Provided document upload token is not valid',
        verificationLimitExceeded: 'We\'re glad you\'re enthusiastic, but it looks like you\'ve already redeemed or attempted to redeem this offer.',
        apiRateLimitExceeded: 'Unable to process your request at this time, please try again later',
        docReviewLimitExceeded: 'Document review limit exceeded',
        maxMetadataValuesExceeded: 'Maximum number of metadata values exceeded',
        maxMetadataLengthExceeded: 'Maximum length of metadata value exceeded',
        unknownError: 'Unknown Error',
        invalidRequest: 'Invalid request',
        invalidApiToken: 'Provided API token was invalid or empty',
        simulatedError: 'This is a simulated error',
        notFound: 'Not found',
        unauthorizedDomain: 'Unauthorized domain',
    },
    step: {
        personalInfo: {
            title: 'VERIFY YOUR DETAILS',
            subtitle: 'Confirm your eligibility by simply completing the form below for this licensed Medical Professional discount offer.',
            howDoesVerifyingWorkDetails: `To be eligible for this offer, you must (1) be a medical professional currently licensed in the United States
                    and (2) be a member of an eligible branch of the medical profession. Eligible branches are shown in the Status
                    selector of this form.<br><br>Nike uses SheerID, a trusted partner, to verify that you are a medical professional.
                    SheerID only collects information that assists in verifying your eligibility.
                    Additional information or documentation may be requested.`,
            tryAgain: {
                title: 'Check Your Name, Postal Code, Birthdate & Organization',
                subtitle: 'Your full name, organization name, postal code, and birthdate must match what is on record with your licensing body.',
            },
        },
        docUpload: {
            title: 'WE NEED YOUR LICENSE OR CERTIFICATE',
            subtitle: 'Documents will be reviewed by staff at SheerID, a trusted partner. During peak times, verification may take up to 3 hours.',
            acceptableUploadExamples: 'Acceptable examples include:',
            acceptedTypes: 'File must be .jpg .jpeg .png .pdf .gif or .bmp',
            addFile: 'Add file',
            cancelButtonLabel: 'Cancel',
            fileInstructions: 'Drag &amp; drop your files here or <span class="sid-dropzone-wrap--link">browse</span>',
            footer: '',
            submitButtonLabel: 'SUBMIT FOR REVIEW',
            rejectedSubtitle: 'We were unable to confirm your eligibility due to:',
            howDoesVerifyingWorkDetails: `Document review is handled by SheerID, a trusted partner who specializes in verifying
                    medical professionals.<br><br>Documents are used only for verifying your medical professional status is
                    current and will be permanently deleted after review is finalized. They will not be shared with {companyName}.`,
            uploadInstructions: 'Upload an official document that shows:',
            rejectionReasons: {
                DOCUMENT_UNREADABLE: 'The document you submitted was unreadable due to poor image quality. Please make sure you have a clearly legible image that\'s bright and crisp, and try submitting again.',
                DOCUMENT_PASSWORD_PROTECTED: 'We are unable to accept password protected documents.',
                DOCUMENT_LIKELY_FRAUD: 'The document you submitted is insufficient for establishing eligibility for this offer.',
                DOCUMENT_UNSUPPORTED: 'The document you submitted is not on the list of accepted document types.',
                DOCUMENT_HANDWRITTEN: 'We cannot accept handwritten documents.',
                MISSING_INFORMATION: 'The document you submitted does not provide all of the information necessary to determine eligibility for this offer.',
                MISSING_INFORMATION_PERSON_NAME: 'The document you submitted is missing a first and/or last name.',
                MISSING_INFORMATION_ORGANIZATION_NAME: 'The document you submitted does not include an organization name that confirms your connection to that organization.',
                DOCUMENT_EXPIRED: 'The document you submitted has expired.',
                DOCUMENT_OUTDATED: 'The document you submitted is missing an issue date or was issued too far in the past.',
                MISMATCH_PERSON_NAME: 'The information on the document you submitted does not match the first and/or last name submitted on the verification form.',
                MISMATCH_ORGANIZATION: 'The organization name on the document(s) you submitted does not match the organization you listed on the verification form.',
                MISMATCH_STATUS: 'The status on the document you submitted does not match the status you listed on your verification form.',
                INELIGIBLE_ORGANIZATION: 'The organization on the document you submitted is not eligible for this offer.',
                MISSING_INFORMATION_UNIVERSITY_ENROLLMENT: 'The document you submitted does not prove enrollment in the current term.',
                INELIGIBLE_PERSON_HIGH_SCHOOL_STUDENT: 'High School Students are not eligible for this offer.',
                MISSING_INFORMATION_AFFILIATION_US_ARMED_FORCES: 'The document you submitted is does not show affiliation to an eligible branch of the United States Armed Forces.',
                MISMATCH_COMPANY_NAME_OR_ADDRESS: 'The company name or address in your document does not match what you entered on the verification form.',
                PAYSTUB_OUTDATED_LAST_30_DAYS: 'Please upload a paystub that was issued within the last 30 days.',
                MISSING_INFORMATION_BIRTHDATE: 'The document you submitted is missing a birthdate, or your age is ineligible for this offer.',
                MISMATCH_BIRTHDATE: 'The birthdate on the document you submitted does not match the birthdate you listed on the verification form.',
                DOCUMENT_OUTDATED_FACULTY: 'The document you submitted does not prove employment in the current academic year.',
                MISSING_OR_MISMATCH_JOB_TITLE: 'The job title on the document you submitted is missing or does not match what you entered on the verification form.',
                OTHER_CONTACT_US: 'We are having problems verifying your eligibility for the offer. Please contact SheerID customer service for help: customerservice@sheerid.com',
                PERSON_FIELD_MISMATCH: 'A field in the document provided did not match with what was provided on the verification form.',
            },
            uploadInfo: {
                fullName: 'Your full name',
                student: {
                    enrollmentDate: 'Date proving enrollment for the current term (or within the last 3 months)',
                    school: 'Your school',
                },
                teacher: {
                    currentSchoolYear: 'A date in the current school year',
                    school: 'Your school',
                },
                military: {
                    currentAffiliation: 'Your current affiliation with the armed services',
                    dischargeDate: 'Your discharge date (if applicable)',
                    serviceBranch: 'Your branch of service',
                    uploadInstructionsDependent: 'Please upload a document that clearly shows your first name, last name, valid dates and status',
                },
                senior: {
                    birthDate: 'Your date of birth',
                },
                age: {
                    birthDate: 'Your date of birth',
                },
                firstResponder: {
                    currentAffiliation: 'Your current affiliation with that organization',
                    organization: 'Your organization',
                },
                medical: {
                    status: 'Your medical professional status',
                    validDate: 'A currently valid date',
                },
                employment: {
                    company: 'Your company',
                    currentAffiliation: 'Your current affiliation with that company',
                },
            },
            acceptableUploads: {
                student: {
                    idCard: 'School ID card with expiration date',
                    classSchedule: 'Class schedule',
                    tuitionReceipt: 'Tuition receipt',
                },
                teacher: {
                    idCard: 'Teacher ID card with valid date',
                    payStub: 'Pay stub from within last 60 days',
                },
                member: {
                    idCard: 'Membership Document',
                    payStub: 'Pay stub from within last 90 days',
                },
                senior: {
                    birthCertificate: 'Your birth certificate',
                    driversLicense: 'Your drivers license',
                    passport: 'Your passport',
                    stateId: 'Your state-issued ID',
                },
                age: {
                    birthCertificate: 'Your birth certificate',
                    driversLicense: 'Your drivers license',
                    passport: 'Your passport',
                    stateId: 'Your state-issued ID',
                },
                military: {
                    activeDuty: 'Any document that proves you are currently serving under Title 10 Active Duty Orders for 30 days or more',
                    veteran: 'Any document that proves you met the qualifications of military service and were honorably discharged',
                    reservistA: 'Any document that shows you are currently serving in the National Guard or a Reserve Component of The United States Armed Forces',
                    retiree: 'Any document that proves you are a Retiree from the US Armed Forces',
                    dependent: 'Any document that proves you are a Registered Military Dependent',
                },
                medical: {
                    licenseCertificate: 'Certificate of license',
                    idCard: 'Nursing ID card with expiration date',
                    photoPayStub: 'Photo ID and recent Pay Stub',
                },
                employment: {
                    employeeIdCard: 'Employee ID Card',
                    payStub: 'Pay stub from within last 60 days',
                    officialLetter: 'An official letter',
                },
            },
        },

        pending: {
            title: 'UPLOAD SUCCESS',
            titleReview: 'UPLOAD SUCCESS',
            titleCountdown: 'PROCESSING',
            subtitle: 'Documents will be reviewed by staff at SheerID, a trusted partner. During peak times, verification may take up to 3 hours.',
            subtitle2: 'Wait here or let us notify you of the outcome.',
            subtitle3: 'NOTE: If you do not receive an email within the time shown above, you may want to check your junk/spam folder for the message.',
            subtitleCountdown: 'Hang tight while we upload and scan your documents.',
        },
        success: {
            title: 'CONGRATULATIONS!',
            subtitle: "You've been verified. Below is your single use promo code which can be used during checkout on <a class='sid-link' href='https://www.nike.com' target='_blank'>www.nike.com</a> or in the Nike App. This promo code will expire in two weeks. During checkout, you must be logged in as a <a class='sid-link' href='https://www.nike.com/membership' target='_blank'>Nike Member</a> to redeem. This promo code cannot be combined with any other offer or promotion.",
            copyCouponCode: 'Copy Coupon code',
            emailNotification: 'We have emailed you a copy so you can use your new code now or later. Look for the email from verify@sheerid.com.',
            verificationOnly: "To make sure you have every opportunity to use your discount, we are also emailing you this promo code so that you can shop now, or shop later. Please check for an email from us (verify@sheerid.com) for all the details.",
            codeText: 'Promo code:',
            thanks: 'Thank you for your service',
        },
        sso: {
            title: 'Verify using your school credentials',
            subtitle: "Please sign in to your school's web portal. It will open in a new tab.",
            subtitle2: "Can't sign in to your email?",
            login: 'Sign in to my school',
            cancel: 'Upload proof of employment',
        },
        smsLoop: {
            title: "We've sent an SMS message to the mobile number ending in {number}. Enter your code here.",
            verificationCode: 'Verification Code',
            errors: {
                codeVerification: 'Verification code could not be validated.',
                codeExpired: 'Verification code could not be validated.',
                codeResendLimit: 'Maximum number of re-tries has been reached.',
                resend: 'Error sending the SMS message',
            },
            successResend: 'SMS message re-sent successfully',
            incorrectNumber: {
                incorrectNumber1: 'Incorrect number? ',
                incorrectNumber2: 'Click here',
                incorrectNumber3: '.',
            },
            resendButton: 'Re-send',
            submitButton: 'Submit',
        },
    },
};
